import t from 'react-translate';
import { css } from '@emotion/react';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import { gray6, white } from 'styles/global_defaults/colors';
import { config } from '@config/pendo.config.json';
import { tripleSpacing } from 'styles/global_defaults/scaffolding';

type BackRoleplayDetailsButtonProps = {
  onBackToRolePlay?: () => void;
};

const styles = css`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${white};
  border-bottom: 1px solid ${gray6};
  /* Negative margins counteract the 140px side padding from getModalBodyStyles(2). */
  margin-left: -140px;
  margin-right: -140px;
  padding-left: 140px;
  padding-right: 140px;
  height: ${tripleSpacing}px;
`;

const BackRoleplayDetailsButton = ({ onBackToRolePlay }: BackRoleplayDetailsButtonProps) => (
  <div css={styles} className='d-flex align-items-center'>
    <ClickableContainer
      onClick={onBackToRolePlay}
      className='d-flex text-primary align-items-center justify-content-start font-weight-bold'
      aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_BACK_TO_ROLEPLAY()}
      data-qa={config.pendo.activities.aiRolePlay.configModal.editCharacterBack}
    >
      <NvIcon icon='back' size='smallest' className='mr-2' />
      <div className='lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_BACK_TO_ROLEPLAY()}
      </div>
    </ClickableContainer>
  </div>
);

export default BackRoleplayDetailsButton;
